import { render, staticRenderFns } from "./SearchPatient.vue?vue&type=template&id=6bcc9675&scoped=true"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"
import style0 from "./SearchPatient.vue?vue&type=style&index=0&id=6bcc9675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc9675",
  null
  
)

export default component.exports